export default __webpack_public_path__ + "static/media/Parvathy T J1.213aa024.jpg";